import "components/Can/components/NoAccess/NoAccess.scss";

const NoAccess = () => {
  return (
    <div className="NoAccess">
      <h1>{"You don't have access to see this page"}</h1>
    </div>
  );
};

export default NoAccess;
